import React, { useEffect } from 'react';
import { SingletonSharedData } from '../../js/singletonSharedData';

const sharedData = new SingletonSharedData();

const AlertAudioFocusTab = () => {
    
    const onFocus = () => {
        sharedData.setIsTabFocused(true);
    };
    
    // User has switched away from the tab (AKA tab is hidden)
    const onBlur = () => {
        sharedData.setIsTabFocused(false);
    };

    
    useEffect(() => {
        window.addEventListener("focus", onFocus);
        window.addEventListener("blur", onBlur);
        // Calls onFocus when the window first loads
        onFocus();
        // Specify how to clean up after this effect:
        return () => {
            window.removeEventListener("focus", onFocus);
            window.removeEventListener("blur", onBlur);
        };
  }, []);

    return null;
};

export default AlertAudioFocusTab;


// WEBPACK FOOTER //
// ./src/components/Alerts/AlertAudioFocusTab.jsx